import { TopBarDropdownContextWrapper } from 'Components/TopBar/contexts/TopBarDropdownContextWrapper';
import React from 'react';
import { TopBarDropdownContent } from './TopBarDropdownContent';

export const TopBarDropdown: React.FC = () => (
  <TopBarDropdownContextWrapper>
    <TopBarDropdownContent />
  </TopBarDropdownContextWrapper>
);
